module.exports = __webpack_public_path__ + "static/assets/8cfddfbe9460933fa85af8f1638b790f.svg";